// Types sourced from the generated OpenAPI schema (../api.gen.d.ts).
// Regenerate with scripts/generate-www-api-types.sh after backend changes.
import type { components } from '../api.gen';

export type SampleStatus = components['schemas']['SampleListItem']['status'];
export type SampleScore = components['schemas']['SampleScore'];
export type SampleListItem = components['schemas']['SampleListItem'];
export type SamplesResponse = components['schemas']['SamplesResponse'];

export const STATUS_OPTIONS: { value: SampleStatus; label: string }[] = [
  { value: 'success', label: 'Success' },
  { value: 'error', label: 'Error' },
  { value: 'context_limit', label: 'Context Limit' },
  { value: 'time_limit', label: 'Time Limit' },
  { value: 'working_limit', label: 'Working Limit' },
  { value: 'message_limit', label: 'Message Limit' },
  { value: 'token_limit', label: 'Token Limit' },
  { value: 'cost_limit', label: 'Cost Limit' },
  { value: 'operator_limit', label: 'Operator Limit' },
  { value: 'custom_limit', label: 'Custom Limit' },
];
